import UserIcon from '@/icons/User'
import FamilyIcon from '@/icons/People'
import WorkIcon from '@/icons/Company'
import { LinkTypeParam } from '@/types'

import s from './Pill.module.css'

type Props = {
  type: LinkTypeParam
}

const text = {
  personal: 'Personal',
  shared: 'Shared',
  organization: 'Work',
  team: 'Work/Team',
}

export const Pill = ({ type }: Props) => {
  return (
    <div className={`${s.pill} ${s[type]}`}>
      {type === 'personal' && <UserIcon fill="#853EA9" />}
      {type === 'shared' && <FamilyIcon fill="#C29B00" />}
      {(type === 'organization' || type === 'team') && (
        <WorkIcon fill="#258697" />
      )}
      {text[type]}
    </div>
  )
}
